import { Tokens } from '@/assets/tokens'
import styled from 'styled-components'

export const DashboardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;
  width: 100%;
  padding-bottom: 24px;
`

export const EngagementGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 12px;
  width: 100%;
`

export const BreakdownsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  width: 100%;

  @media (max-width: 1300px) {
    grid-template-columns: 1fr;
  }
`

export const BreakdownSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const BreakdownTitle = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: ${Tokens.ColorTextPrimary};
`

export const BreakdownList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const BreakdownRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const BreakdownHeader = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
`

export const BreakdownLabel = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: ${Tokens.ColorTextPrimary};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const BreakdownValue = styled.span`
  font-size: 12px;
  color: ${Tokens.ColorTextSecondary};
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
`

export const BreakdownTrack = styled.div`
  width: 100%;
  height: 8px;
  border-radius: 4px;
  background-color: ${Tokens.ColorBackground};
  overflow: hidden;
`

export const BreakdownFill = styled.div<{ $percentage: number; $color: string }>`
  height: 100%;
  border-radius: 4px;
  background-color: ${({ $color }) => $color};
  width: ${({ $percentage }) => Math.min(100, Math.max(0, $percentage))}%;
  transition: width 0.3s ease;
`

export const ChannelRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: 14px;

  &:first-child {
    padding-top: 0;
  }

  &:not(:first-child) {
    border-top: 1px solid ${Tokens.ColorBorder};
  }
`

export const ChannelMetricRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const MetricLabel = styled.span`
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  color: ${Tokens.ColorTextTertiary};
`

export const EmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 0;
  color: ${Tokens.ColorTextSecondary};
  font-size: 13px;
`
